export enum OrgOrgRelType {
    DIRECT,
    REPORT,
    SERVICEPROVIDER,
    SHARE
}

export enum CategoryType {
    ORGANIZATION = "ORGANIZATION",
	FORMLGROUP = "FORMLGROUP",
	INFORMALGROUP = "INFORMALGROUP"
}

export enum PresentationObject {
	BIZ_GROUP = "BIZ_GROUP",
	GENERAL_RELATIONSHIP = "GENERAL_RELATIONSHIP",
	BIZ_GROUP_RELATIONSHIP = "BIZ_GROUP_RELATIONSHIP"
}

export const DnDItemTypes = {
    ORG: 'organization',
    HEADER: 'header',
    POSITION: 'position'
};

export enum UserRoleType {
    COORDINATOR = 'Coordinator',
    FRENCHTRANSLATOR ='FrenchTranslator',
    ADMINISTRATOR = 'Administrator',
    RESTADMIN = 'RestAdmin'
}

export enum ReportType {
    RPT_MINISTRY_DATA = 'RPT_MINISTRY_DATA',
    RPT_HIERARCHY = 'RPT_HIERARCHY',
    RPT_PIT_DETAILS = 'RPT_PIT_DETAILS',
    RPT_PIT_HIERARCHY = 'RPT_PIT_HIERARCHY'
}

export enum Language {
    EN = 'EN',
    FR = 'FR'
}

export  const formatExcludeComma = /[`!@#$%^*=\[\]{};:"\\|<>?~]/;

export const breakpoint = /[ &()+/_-]/;

export const SESSION_TIMEOUT = 44 * 60 * 1000;